import { modalRenderer } from '~/modal/modalRendererRegistry';
import { GroupingToolHintComponent } from './GroupingToolHint.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    GroupingToolHint: undefined;
  }
}
modalRenderer.register('GroupingToolHint', GroupingToolHintComponent);
